<section class="photos-header">
  <div>
    <button type="button" class="link-button" [routerLink]="['/jobs', jobId]"><span class="back-icon" aria-hidden="true"></span><span>Back to Job</span></button>
    <h1>Property Photos</h1>
    @if (job?.address; as address) {
      <p>{{ address }}</p>
    }
  </div>
  <div class="photo-actions">
    @if (isIpad) {
      <div class="ipad-upload-picker">
        <button type="button" class="btn secondary" (click)="toggleIpadUploadOptions()" [disabled]="uploading" aria-haspopup="menu" [attr.aria-expanded]="showIpadUploadOptions">
          {{ uploading ? 'Uploading...' : 'Upload Photos' }}
        </button>
        @if (showIpadUploadOptions) {
          <div class="ipad-upload-options" role="menu" aria-label="Upload photo options">
            <label class="btn secondary upload-button" role="menuitem">
              Photo Library
              <input type="file" accept="image/png,image/jpeg,image/heic,image/heif" multiple (change)="upload($event)" [disabled]="uploading" />
            </label>
            <label class="btn secondary upload-button" role="menuitem">
              Take Photo
              <input type="file" accept="image/*" capture="environment" (change)="upload($event)" [disabled]="uploading" />
            </label>
          </div>
        }
      </div>
    } @else {
      <label class="btn secondary upload-button">
        {{ uploading ? 'Uploading...' : 'Upload Photos' }}
        <input type="file" accept="image/*" multiple (change)="upload($event)" [disabled]="uploading" />
      </label>
    }
  </div>
</section>

<section class="photo-card">
  <h2>Saved Photos</h2>
  @if (loading) {
    <div class="photo-grid">
      @for (item of [1,2,3,4]; track item) {
        <div class="photo-skeleton"></div>
      }
    </div>
  } @else if (photos.length) {
    <div class="photo-grid">
      @for (photo of photos; track photo.id) {
        <article class="photo-item">
          @if (isUnsyncedPhoto(photo)) {
            <div class="photo-menu">
              <button type="button" class="photo-menu-trigger" (click)="togglePhotoMenu($event, photo)" aria-label="Photo actions" aria-haspopup="menu" [attr.aria-expanded]="openPhotoMenuId === photo.id">
                <span aria-hidden="true">&#8942;</span>
              </button>
              @if (openPhotoMenuId === photo.id) {
                <div class="photo-menu-panel" role="menu" aria-label="Photo actions">
                  <button type="button" class="photo-menu-action" role="menuitem" (click)="openPhotoEdit($event, photo)" [disabled]="savingPhotoEdit">
                    Edit
                  </button>
                  <button type="button" class="photo-menu-action danger" role="menuitem" (click)="deleteUnsyncedPhoto($event, photo)" [disabled]="deletingPhotoId === photo.id">
                    Delete
                  </button>
                </div>
              }
            </div>
          }
          <div class="photo-title">
            <p>{{ photo.label || 'Property photo' }}</p>
          </div>
          <div class="image-frame">
            <img [src]="photoSource(photo)" [alt]="photo.label || 'Property photo'" />
          </div>
          <div class="photo-details">
            <dl class="photo-metadata">
              <div>
                <dt>Display Order</dt>
                <dd>
                  <select [ngModel]="photo.displayOrder || '00'" (ngModelChange)="updatePhotoDisplayOrder(photo, $event)" [disabled]="updatingDisplayOrderIds.includes(photo.id)" aria-label="Display order">
                    @for (displayOrder of displayOrderOptions; track displayOrder) {
                      <option [value]="displayOrder">{{ displayOrder }}</option>
                    }
                  </select>
                </dd>
              </div>
              <div>
                <dt>Image Type</dt>
                <dd>{{ imageTypeLabel(photo) }}</dd>
              </div>
            </dl>
          </div>
        </article>
      }
    </div>
  } @else {
    <div class="empty-state">{{ isIpad ? 'No photos added yet. Add photos from the library or take a new photo.' : 'No photos added yet. Upload photos here, or use the Camera button on the job.' }}</div>
  }
</section>

@if (editingPhoto) {
  <div class="photo-review-backdrop" role="presentation">
    <section class="photo-review-modal" role="dialog" aria-modal="true" aria-label="Edit photo details">
      <header>
        <h2>Edit Photo</h2>
      </header>

      <img [src]="photoSource(editingPhoto)" [alt]="editingPhoto.label || 'Photo preview'" />

      <label>
        <span>Image Name</span>
        <input [(ngModel)]="editingPhotoName" [disabled]="savingPhotoEdit" />
      </label>

      <label>
        <span>Image Type</span>
        @if (imageList.length) {
          <select [(ngModel)]="editingPhotoImageType" [disabled]="savingPhotoEdit" aria-label="Image type">
            <option value="">Select an image type...</option>
            @for (image of imageList; track image.value) {
              <option [value]="image.value">{{ image.label }}</option>
            }
          </select>
        } @else {
          <input [(ngModel)]="editingPhotoImageType" [disabled]="savingPhotoEdit" />
        }
      </label>

      <footer>
        <button type="button" class="review-cancel" (click)="closePhotoEdit()" [disabled]="savingPhotoEdit">Cancel</button>
        <button type="button" class="review-save" (click)="savePhotoEdit()" [disabled]="savingPhotoEdit">
          {{ savingPhotoEdit ? 'Saving...' : 'Save' }}
        </button>
      </footer>
    </section>
  </div>
}
